import { ExperimentProvider } from '@/providers/experiment';
import { supabase } from '@/services/supabase';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/desktop')({
  component: DesktopLayout,
  loader: async () => {
    const { data } = await supabase.auth.getSession();
    const userId: string | undefined = data.session?.user?.user_metadata?.p_id;
    return { userId };
  },
});

function DesktopLayout() {
  const { userId } = Route.useLoaderData();

  return (
    <ExperimentProvider userId={userId}>
      <Outlet />
    </ExperimentProvider>
  );
}
